import { FC } from 'react';

interface CalendarProps {}

const InvoiceIcon: FC<CalendarProps> = (props: CalendarProps) => {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M4.7999 17.4V9.59995H6.5999V17.4H4.7999ZM11.0999 17.4V9.59995H12.8999V17.4H11.0999ZM2.3999 20.4V18.6H21.5999V20.4H2.3999ZM17.3999 17.4V9.59995H19.1999V17.4H17.3999ZM2.3999 8.39995V5.99995L11.9999 1.19995L21.5999 5.99995V8.39995H2.3999ZM5.2249 6.59995H18.7749L11.9999 3.22495L5.2249 6.59995Z'
                fill='black'
            />
        </svg>
    );
};

export default InvoiceIcon;
